import { memo } from 'react'

import { RefreshOutlined } from '@mui/icons-material'
import { Button, Tooltip } from '@collaborate-health/uikit'

export interface RefreshButtonProps {
  disabled?: boolean
  onClick: () => void
}

const RefreshButton: React.FC<RefreshButtonProps> = ({ disabled = false, onClick }) => {
  return (
    <Tooltip text='Refresh'>
      <span>
        <Button
          color='primary'
          disabled={disabled}
          size='small'
          startIcon={<RefreshOutlined />}
          variant='outlined'
          onClick={onClick}
        >
          Refresh
        </Button>
      </span>
    </Tooltip>
  )
}

export default memo(RefreshButton)

